var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['zg-form-error', {
    'zg-form-error--visible': _vm.visible,
    [`zg-form-error--type-${_vm.type}`]: _vm.type
  }]},[_c('zg-messaging-inline-text',{attrs:{"type":_vm.type,"background":"none","padding":"xsmall"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }